import { FetchAPI } from './auth-service';


class ValidatorzDataService {
    constructor () {
        if (!ValidatorzDataService.instance) {
            ValidatorzDataService.instance = this;
        }

        this.customGeoIP = (val) => {
            return FetchAPI({
                method: 'GET',
                url: `validatorz/custom_geoip_expr/${val}`,
            });
        };

        this.gator = (gator) => {
            return FetchAPI({
                method: 'POST',
                url: 'validatorz/gator_expr/',
                plain: true,
                body: gator,
            });
        };

        this.suriVars = (data) => {
            return FetchAPI({
                method: 'POST',
                url: `validatorz/suri_vars/`,
                body: data
            });
        };

        return ValidatorzDataService.instance;
    }
}

const ValidatorzService = new ValidatorzDataService();

export default ValidatorzService;
